// 导出所有组件
export { default as MapComponent } from './Map/src/index.vue'

// 导出默认安装函数
import MapComponent from './Map/src/index.vue'

const install = (app) => {
  app.component('MapComponent', MapComponent)
}

export default {
  install,
  MapComponent
}